import { render, staticRenderFns } from "./hkTip.vue?vue&type=template&id=3ed55b94&scoped=true"
import script from "./hkTip.vue?vue&type=script&lang=js"
export * from "./hkTip.vue?vue&type=script&lang=js"
import style0 from "./hkTip.vue?vue&type=style&index=0&id=3ed55b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed55b94",
  null
  
)

export default component.exports